import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Smartphone } from "lucide-react";
import { Wordmark } from "@/components/Wordmark";

const links = [
  { to: "/main-event", label: "Main Event" },
  { to: "/mini-salons", label: "Mini Salons" },
  { to: "/exhibit", label: "Exhibit" },
  { to: "/exhibitors", label: "Exhibitors" },
  { to: "/sponsors", label: "Sponsors" },
  { to: "/judges", label: "Judges" },
  { to: "/gallery", label: "Gallery" },
  { to: "/news", label: "News" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all ${scrolled ? "glass" : "bg-transparent"}`} data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between">
        <Wordmark size="text-2xl sm:text-3xl" showArrow={false} />
        <nav className="hidden lg:flex items-center gap-6">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={`font-heading text-sm uppercase tracking-wide transition-colors hover:text-[#ff7a1a] ${location.pathname === l.to ? "text-[#ff7a1a]" : "text-white/80"}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/app" className="pas-btn text-sm hidden sm:inline-flex" data-testid="nav-open-app">
            <Smartphone size={16} /> Open App
          </Link>
          <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden glass border-t border-white/10 px-4 py-4 space-y-1" data-testid="mobile-menu">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="block py-2.5 font-heading uppercase text-white/85 hover:text-[#ff7a1a]">
              {l.label}
            </Link>
          ))}
          <Link to="/app" className="pas-btn w-full mt-3">Open App</Link>
        </div>
      )}
    </header>
  );
}
